import React, { useState, useEffect } from 'react';
import ky from 'ky';
import styled from 'styled-components';
import { Grid, Button, TextField, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { authLogin, setLatest } from '../redux/workBackendSlice';
import { resetLocalDB, loadAllDb } from '../redux/dataBackend';
import { generateUserId } from '../redux/userDbSlice';
import useWorkBackend from '../hooks/useWorkBackend';
import useCurrentUserDb from '../hooks/useCurrentUserDb';
import { SignUpDataType, makeInitialUserData, setTokensToCookie } from '../general';
import { apiURL } from './DigimagiProvider';
import Redirector from './Redirector';

const SignUpSceneWrapper = styled.div`
  height: 100vh;
  width: 100vw;
`
const ContainerGrid = styled(Grid)`
  height: inherit;
  width: inherit;
`;
const FormItemGrid = styled(Grid)`
  width: min(80vw, 320px);
`
const UserNameTextField = styled(TextField)`
  width: 100%;
`;

type SignUpSceneProps = {
  redirected: boolean;
  setRedirected: (value: boolean) => void;
}
const SignUpScene: React.FC<SignUpSceneProps> = ({ redirected, setRedirected }) => {
  const dispatch = useDispatch();
  const authUser = useWorkBackend().authUser;
  const [currentUserId, currentUserValue] = useCurrentUserDb();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [enterPassword, setEnterPassword] = useState(false);
  const [rePassword, setRePassword] = useState('');
  const [enterRePassword, setEnterRePassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const backToThePage = (done: boolean) => {
    if (done) {
      const link = document.getElementById('signup-done');
      if (link) {
        link.click();
      }
    } else {
      const link = document.getElementById('signup-cancel');
      if (link) link.click();
    }
  }
  const close = (done: boolean) => {
    setName('');
    setEmail('');
    setPassword('');
    setErrorMessage('');
    backToThePage(done);
  }
  const changePassword = (value: string) => {
    if (!enterPassword) setEnterPassword(true);
    setPassword(value);
  }
  const changeRePassword = (value: string) => {
    if (!enterRePassword) setEnterRePassword(true);
    setRePassword(value);
  }
  const addUserExe = async (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault();
    try {
      dispatch(loadAllDb());
      const sendData = {
        user_id: generateUserId(),
        email: email,
        username: name,
        password: password
      };
      console.log(sendData)
      const res = await ky.post(apiURL + 'account_register', { json: sendData }).json();
      console.log(res)
      const loginData = {
        username: name,
        password: password
      };
      const login = await ky.post(apiURL + 'login', { json: loginData }).json() as any;
      console.log(login)
      setTokensToCookie(login.data);
      dispatch(authLogin(true));

      const language = currentUserValue ? currentUserValue.language : 'ja';
      const data: SignUpDataType = { newId: login.data.user_id, oldId: currentUserId, mail: email, name: name, language };
      console.log(data)

      const callback = async () => {
        dispatch(setLatest(false));
        localStorage.removeItem('loginId');
        await resetLocalDB();
        close(true);
      }
      makeInitialUserData(dispatch, authUser, data, callback);
    } catch (err) {
      console.log(err);
      // if (ev instanceof FirebaseError) {
      //   console.log(ev.code)
      //   if (ev.code === 'auth/invalid-email') setErrorMessage('適切なメールアドレスではありません');
      //   if (ev.code === 'auth/email-already-in-use') setErrorMessage('すでに使用されているメールアドレスです');
      //   if (ev.code === 'auth/weak-password') setErrorMessage('パスワードは6文字以上にしてください');
      // }
    }
  }

  useEffect(() => {
    if (enterPassword && enterRePassword && password !== rePassword) setErrorMessage('パスワードが一致していません');
    else setErrorMessage('');
  }, [enterPassword, enterRePassword, password, rePassword])

  if (!redirected) return <Redirector doneRedirect={() => setRedirected(true)} />;
  else return (
    <SignUpSceneWrapper>
      <ContainerGrid container justifyContent="center" alignItems="center" direction="column" spacing={4}>
        <Grid item>
          <Typography variant="h5" gutterBottom>新規アカウント登録</Typography>
        </Grid>
        <Grid item>
          <form onSubmit={addUserExe} autoComplete="off">
            <ContainerGrid container justifyContent="center" alignItems="center" direction="column" spacing={2}>
              <FormItemGrid item>
                <UserNameTextField label="新しいユーザの名前" defaultValue={name} variant="outlined" required
                  onChange={(e) => setName(e.target.value)} />
              </FormItemGrid>
              <FormItemGrid item>
                <UserNameTextField label="メールアドレス" defaultValue={email} variant="outlined" required
                  onChange={(e) => setEmail(e.target.value)} />
              </FormItemGrid>
              <FormItemGrid item>
                <UserNameTextField label="パスワード" defaultValue={password} variant="outlined" required type="password"
                  onChange={(ev) => changePassword(ev.target.value)} />
              </FormItemGrid>
              <FormItemGrid item>
                <UserNameTextField label="パスワードの再入力" defaultValue={rePassword} variant="outlined" required type="password"
                  onChange={(ev) => changeRePassword(ev.target.value)} />
              </FormItemGrid>
              <FormItemGrid item>
                <Typography variant="caption" color="error" gutterBottom>{ errorMessage }</Typography>
              </FormItemGrid>
              <Grid item>
                <Button color="primary" type="submit" disabled={name === '' || email === '' || password === '' || rePassword === '' || password !== rePassword}>アカウントを作成する</Button>
              </Grid>
            </ContainerGrid>
          </form>
        </Grid>
        <Grid item>
          <Button color="secondary" onClick={() => close(false)}>
            キャンセル
          </Button>
        </Grid>
        <Link id='signup-cancel' to='/userSettings' />
        <Link id='signup-done' to='/doneSignup' />
      </ContainerGrid>
    </SignUpSceneWrapper>
  );
}

export default SignUpScene;
